import { urlComments } from "../../api/urls";
import { apiPost } from "../../api/index";

export default class CommentsEffect {
  static async sendComments(data) {
    const resp = await apiPost(urlComments, data);
    return resp;
  }
}
